import React from 'react';
import { connect } from 'react-redux';
import { WindowStackItem } from '@ff-os/shared-react/context/window-stack/WindowStackItem';
import { GiftPdpDispatch, GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { selectIsArQrWindowOpen, setIsArQrWindowOpen } from '../_redux-ui';
import { WindowArPreviewQrCode } from './WindowArPreviewQrCode';

const _ArQrCodeStackItem = ({ setIsArQrWindowOpen, isArQrWindowOpen }: Props) => {

    if (!isArQrWindowOpen) {
        return null;
    }

    return (
        <WindowStackItem>
            <WindowArPreviewQrCode onClose={() => setIsArQrWindowOpen(false)} />
        </WindowStackItem>
    );
};

type Props = {
    setIsArQrWindowOpen: (value: boolean) => void;
    isArQrWindowOpen: boolean;
};

const mapStateToProps = (state: GiftPdpState) => ({
    isArQrWindowOpen: selectIsArQrWindowOpen(state)
});

const mapDispatchToProps = (dispatch: GiftPdpDispatch) => ({
    setIsArQrWindowOpen: (value: boolean) => dispatch(setIsArQrWindowOpen(value))
});

export const ArQrCodeStackItem = connect(mapStateToProps, mapDispatchToProps)(_ArQrCodeStackItem);